import { createAsyncThunk } from "@reduxjs/toolkit";
import { API_URL } from "../../../app/config";
import { axiosApiInstance } from "../../../app/axios";
import { ErrorToast, SuccessToast } from "../../../components/toast/Toasts";
import { ISeoTag } from "../seotagModel";

export const getAllSeoTag = createAsyncThunk(
  "SeoTags/FindAllSeoTags",
  async () => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/SeoTags/FindAllSeoTags`,
        {}
      );
      return response.data?.Data;
    } catch (error: any) {
      // ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Fetching SeoTag:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const createSeoTag = createAsyncThunk(
  "SeoTags/InsertSeoTags",
  async (SeoTagData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/SeoTags/InsertSeoTags`,
        SeoTagData
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error creating SeoTag:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const updateSeoTag = createAsyncThunk(
  "SeoTags/UpdateSeoTags",
  async (SeoTagData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/SeoTags/UpdateSeoTags`,
        SeoTagData
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error updating SeoTag :", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const deleteSeoTag = createAsyncThunk(
  "SeoTags/DeleteSeoTags",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/SeoTags/DeleteSeoTags`,
        { ID }
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error deleting SeoTag :", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const getSeoTagByID = createAsyncThunk(
  "SeoTags/FindByIDSeoTags",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/SeoTags/FindByIDSeoTags`,
        { ID }
      );
      const result = response.data?.Data as any;
      return {
        ID: result.ID,
        PageName: result.PageName,
        PageUrl: result.PageUrl,
        MetaTitle: result.MetaTitle,
        MetaKeywords: result.MetaKeywords,
        MetaDescription: result.MetaDescription,
        IsActive: result.IsActive ? 1 : 2,
      } as ISeoTag;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error fetching SeoTag :", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const getAllActiveSeoTag = createAsyncThunk(
  "SeoTags/FindAllActiveSeoTags",
  async () => {
    try {
      const response = await axiosApiInstance.get(
        `${API_URL}/SeoTags/FindAllActiveSeoTags`
      );
      return response.data?.Data;
    } catch (error: any) {
      // ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Fetching SeoTages:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const ActiveInactiveSeoTag = createAsyncThunk(
  "SeoTags/ActiveInActiveSeoTags",
  async (formData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/SeoTags/ActiveInActiveSeoTags`,
        formData
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error active-inactive SeoTag :", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);
